/* global MOCK_NEWSLETTER_SETTINGS */
import {
  newsletterFetch,
  newsletterFetchSuccess,
  newsletterUpdate,
  newsletterUpdateSuccess,
  types
} from './'
import { newsletterMockFetch, newsletterMockUpdate } from './mock'

// The mock dispatches the real success action, so everything downstream
// behaves as it will against the live endpoint
const mocked = (dispatch, action) => {
  dispatch(action)
  return Promise.resolve([{ type: 'HIDDEN_FETCHING' }, action])
}

// Resolves { subscribed } or null when the state can't be read
export const dispatchFetchNewsletter = (dispatch) =>
  (MOCK_NEWSLETTER_SETTINGS
    ? mocked(dispatch, newsletterFetchSuccess(newsletterMockFetch()))
    : dispatch(newsletterFetch())
  )
    .then(([_, res]) =>
      res.type === types.NEWSLETTER_FETCH_SUCCESS
        ? { subscribed: Boolean(res.payload.subscribed) }
        : null
    )
    .catch(() => null)

// Resolves { subscribed, status } or { error } (502: Mailchimp unreachable,
// nothing changed). `status: pending` means Mailchimp emailed a confirmation
// link because the contact had unsubscribed itself.
export const dispatchUpdateNewsletter = (dispatch, subscribed) =>
  (MOCK_NEWSLETTER_SETTINGS
    ? mocked(
        dispatch,
        newsletterUpdateSuccess(newsletterMockUpdate(subscribed))
      )
    : dispatch(newsletterUpdate({ subscribed }))
  )
    .then(([_, res]) => {
      // No analytics event (SPEC-099 D8): the opt-in rate comes from the
      // User fields
      if (res.type !== types.NEWSLETTER_UPDATE_SUCCESS)
        return { error: res.payload?.value?.detail || true }
      return {
        subscribed: Boolean(res.payload.subscribed),
        status: res.payload.status
      }
    })
    .catch(() => ({ error: true }))
